import _ from "underscore";
import React, { Component } from "react";
import PropTypes from "prop-types";
import VerticalTab from "./vertical-tab";

class VerticalTabPanel extends Component {
  static propTypes = {
    items: PropTypes.array,
    value: PropTypes.any,
    handleTabChange: PropTypes.func,
  };

  static defaultProps = {
    items: [],
    value: "",
    handleTabChange: () => null,
  };

  renderNavItems = () => {
    return this.props.items.map(item => {
      return (
        <VerticalTab
          key={item.key}
          label={item.label}
          icon={item.icon}
          iconSize={item.iconSize}
          isActive={this.props.value.key === item.key}
          handleClick={() => this.props.handleTabChange(item.key)}
        />
      );
    });
  };

  render() {
    return (
      <div className="et-vertical-tab-panel">
        <nav className="et-vertical-tab-panel--nav">{this.renderNavItems()}</nav>
        <div className="et-vertical-tab-panel--content">
          {_.findWhere(this.props.items, { key: this.props.value.key }).render()}
        </div>
      </div>
    );
  }
}

export default VerticalTabPanel;
